import ApiService from "./api.service";
import mainStore from "../store/mainStore";

class DiscussionProfileService extends ApiService {
    async GetAll() {
        const response = await this.get("api/meeting/discussion-profile");
        if (response.status !== 200) {
            throw await Promise.reject(response);
        }

        mainStore.commit("setAvailableDiscussionProfiles", response.data);
        return response;
    }

    async GetById(id) {
        const response = await this.get(`api/meeting/discussion-profile/${id}`);
        if (response.status !== 200) {
            throw await Promise.reject(response);
        }

        return response;
    }

    async Create(data) {
        const response = await this.post("api/meeting/discussion-profile", data);
        if (response.status !== 201) {
            throw await Promise.reject(response);
        }

        await this.GetAll();
        return response;
    }

    async Update(id, data) {
        const response = await this.put(`api/meeting/discussion-profile/${id}`, data);
        if (response.status !== 204) {
            throw await Promise.reject(response);
        }

        await this.GetAll();
        return response;
    }

    async Delete(id) {
        const response = await this.delete(`api/meeting/discussion-profile/${id}`);
        if (response.status !== 204) {
            throw await Promise.reject(response);
        }

        await this.GetAll();
        return response;
    }

    async GetModes(discussionProfileId) {
        const response = await this.get(`api/meeting/discussion-profile/${discussionProfileId}/modes`);
        if (response.status !== 200) {
            throw await Promise.reject(response);
        }

        return response;
    }

    async GetStatementTypes() {
        const response = await this.get("api/meeting/statement-types");
        if (response.status !== 200) {
            throw await Promise.reject(response);
        }

        return response;
    }

    async AddMode(discussionProfileId, data) {
        const response = await this.post(`api/meeting/discussion-profile/${discussionProfileId}/modes`, data);
        if (response.status !== 201) {
            throw await Promise.reject(response);
        }
        await this.GetAll();
        return response;
    }

    async GetModeById(discussionProfileId, modeId) {
        const response = await this.get(`api/meeting/discussion-profile/${discussionProfileId}/modes/${modeId}`);
        if (response.status !== 200) {
            throw await Promise.reject(response);
        }

        return response;
    }

    async UpdateMode(discussionProfileId, modeId, data) {
        const response = await this.put(`api/meeting/discussion-profile/${discussionProfileId}/modes/${modeId}`, data);
        if (response.status !== 204) {
            throw await Promise.reject(response);
        }

        return response;
    }

    async DeleteMode(discussionProfileId, modeId) {
        const response = await this.delete(`api/meeting/discussion-profile/${discussionProfileId}/modes/${modeId}`);
        if (response.status !== 204) {
            throw await Promise.reject(response);
        }
        await this.GetAll();
        return response;
    }
}

export default new DiscussionProfileService();
